import { IonButton, IonCard, IonIcon, IonImg } from "@ionic/react";
import { arrowForward } from "ionicons/icons";
import { ReactComponent as CardBackgroundImage } from "../assets/graphics/bot-bg.svg";
import darkBotIcon from "../assets/graphics/bot-dark.png";
import { ReactComponent as EyeIcon } from "../assets/graphics/bot-eye.svg";
import { ReactComponent as CandlesIcon } from "../assets/graphics/candles.svg";
import { useLobbiesStore } from "../stores/lobbies.store";
import { useUsersStore } from "../stores/users.store";

const ChallengeCard: React.FC = () => {
  const activeChallenge = useLobbiesStore(state => state.activeChallenge);
  const quoCoin = useUsersStore(state => state.user?.quoCoin || 0);
  return (
    <>
      <IonCard
        className="p-2 button bg-primary-90 h-fit -mt-2 mb-2 mx-0 relative w-full m-4 w-full p-4 border rounded-xl mt-2 border-primary"
        disabled={quoCoin < 3}
        routerLink={
          activeChallenge ? `/challenge/${activeChallenge}` : "/challenge"
        }
      >
        <CardBackgroundImage className="absolute inset-0 w-full h-full" />
        <CandlesIcon className="absolute -top-4 right-20" />
        <IonImg
          className="absolute w-[132px] h-[132px] -right-1 top-2"
          src={darkBotIcon}
        />
        <EyeIcon className="absolute right-[20px] top-10" />
        <EyeIcon className="absolute right-[58px] top-11" />
        <div className="uppercase text-secondary text-xs font-semibold py-2">
          Instant Lobby
        </div>
        <div className="text-2xl text-white font-semibold pb-4">
          QuidPro Challenge
        </div>
        <IonButton color="primary" routerLink="/challenge">
          Set challenge
          <IonIcon slot="end" icon={arrowForward} />
        </IonButton>
      </IonCard>
    </>
  );
};

export default ChallengeCard;
